/**
 * TypeScript interfaces for the dashboard module
 */

export interface ApiData {
  uuid: string;
  entity_type_id: string;
  company_id: number;
  satisfies_schema?: boolean;
  payload: { [key: string]: any };
  created: string;
  deleted: boolean;
  download_date?: string;
}

export enum EntityID {
  MONTHLY_KPIS = "monthly-kpis",
  GASTO_INGRESO = "gasto-ingreso",
  CLIENTE_PROVEEDOR = "cliente-proveedor",
  PYG_GRUPOS = "pyg-grupos",
  PYG_DATA = "pyg-data",
}

export interface MonthlyKpis {
  mes_ejercicio: string;
  ingresos: number;
  gastos: number;
  beneficio: number;
}

export interface ClientesProveedores {
    mes_ejercicio: string;
    is_gasto: boolean;
    descripcion: string;
    total: number;
    cuenta: string;
}

export interface GastosIngresos {
  mes_ejercicio: string;
  is_gasto: boolean;
  descripcion: string;
  total: number;
  cuenta: string;
}

export interface CreateEntityInstance {
  company_id: number;
  entity_type_id: string;
  payload: { [key: string]: any };
}

export interface CompanyEjercicio {
  ejercicio: number;
  link_path: string;
}

export interface UltimasFacturas {
  id: string;
  fecha: string;
  origen: string;
  tipo: string;
  importe: number;
  estado: string;
}

export interface PygGrupo {
    concept: string;
    clave_num: string;
    accounts: string[];
    type: string;
}

export interface PygData {
    mes_ejercicio: string;
    clave_num: string;
    concept: string;
    total: number;
}